import React from "react";
import "./TourDaySelection.css";
import ReservationCalendar from "components/ReservationCalendar/ReservationCalendar";
import WrappedReservationManager from "components/ReservationCalendar/ReservationManager";

const TourDaySelection = () => {

    return (
        <div className="tourDaySelection">
            {/* <ReservationCalendar/> */}
            <WrappedReservationManager/>
        </div>
    );
}

export default TourDaySelection;